export const highlight = (isHighlighted?: boolean) => {
  return isHighlighted ? 'border-accent-red border border-dashed border-2' : '';
};
